import { render, staticRenderFns } from "./assessmentList.vue?vue&type=template&id=f0ed1940&scoped=true&"
import script from "./assessmentList.vue?vue&type=script&lang=ts&"
export * from "./assessmentList.vue?vue&type=script&lang=ts&"
import style0 from "./assessmentList.vue?vue&type=style&index=0&id=f0ed1940&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ed1940",
  null
  
)

export default component.exports